import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';

import { map, Observable, take } from 'rxjs';

import { ButtonMode, ButtonTheme, ModalButtons } from '@fcom/ui-components';
import { CmsArticle } from '@fcom/core-api/interfaces';
import { FragmentService } from '@fcom/common/services';
import { GtmService } from '@fcom/common/gtm';
import { ElementTypes, GaContext } from '@fcom/common/interfaces';

const GTM_ELEMENT_NAME = 'kids-in-business-modal';

@Component({
  selector: 'fin-kids-in-business-notification',
  templateUrl: './kids-in-business-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KidsInBusinessNotificationComponent {
  public readonly ModalButtons = ModalButtons;
  public readonly ButtonTheme = ButtonTheme;
  public readonly ButtonMode = ButtonMode;
  public readonly content$: Observable<CmsArticle[]>;
  public readonly headerStyles = ['font-heading-4'];

  modalOpen = false;
  checkboxChecked = false;
  showErrorMessage = false;

  @Output()
  continue: EventEmitter<void> = new EventEmitter();

  @Output()
  cancel: EventEmitter<void> = new EventEmitter();

  @ViewChild('errorMessage', { static: false })
  errorMessage: ElementRef;

  constructor(
    private fragmentService: FragmentService,
    private gtmService: GtmService,
    private cdr: ChangeDetectorRef
  ) {
    this.content$ = this.fragmentService.getFragment<CmsArticle>('fragments.kidsInBusinessNotice.url').pipe(
      take(1),
      map((fragment) => fragment.items as CmsArticle[])
    );
  }

  onCheckboxChange(checked: boolean): void {
    this.checkboxChecked = checked;
    if (checked) {
      this.showErrorMessage = false;
    }
  }

  openModal(): void {
    this.modalOpen = true;
    this.cdr.markForCheck();
    this.trackModalAction('open');
  }

  emitContinue(): void {
    if (this.checkboxChecked) {
      this.continue.emit();
      this.trackModalAction('continue');
    } else {
      this.showErrorMessage = true;
      setTimeout(() => {
        this.errorMessage?.nativeElement.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
      }, 0);
    }
  }

  emitCancel(): void {
    this.checkboxChecked = false;
    this.cancel.emit();
    this.trackModalAction('cancel');
  }

  closeModal(): void {
    this.checkboxChecked = false;
    this.modalOpen = false;
    this.trackModalAction('close');
  }

  private trackModalAction(action: string): void {
    this.gtmService.trackElement(GTM_ELEMENT_NAME, GaContext.BOOKING_FLOW, ElementTypes.MODAL, undefined, action);
  }
}
